/**
 * @generated SignedSource<<ae0585790b98faa6f42e78cd820a35d3>>
 * @relayHash 14ad3dca732756dca6246ef351d7319c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7c7de3e7f6623bcc94de30375e35240729aa179a60490aef983d5b1350f9cd75

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiDevOpsBoardQuery } from './uiDevOpsBoardQuery.graphql';

const node: PreloadableConcreteRequest<uiDevOpsBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7c7de3e7f6623bcc94de30375e35240729aa179a60490aef983d5b1350f9cd75",
    "metadata": {},
    "name": "uiDevOpsBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
